import React from "react";
import { withRouter } from "react-router-dom";
import { InputElement } from "../../shared/FormElements";
import { REGISTRATION_STATUS } from "../../../actions/actionTypes";

const EventRegister = props => {

  const returnElement = () => {
    switch(props.status) {
      case REGISTRATION_STATUS._WAITING:
        return ( 
          <>
            <div>{signInStructure}</div>
            <button
              type="submit"
              className={
                props.btnDisabled ? "btn inactive" : "btn active"
              }
              disabled={props.btnDisabled ? "disabled" : ""}
              onClick={() => props.registerHandler()}
            >
              Register
            </button>  
          </>
        )
      case REGISTRATION_STATUS._LOADING:
        return (
          <>
            <div>{signInStructure}</div>
            <div className="registering-text">Registering...</div>
          </>
        )
      case REGISTRATION_STATUS._SUCCESS:
        return (             
          <div className="registration-successful">Registered Successfully !  <a href="/upcoming-events"> Explore more events </a></div>            
        )
      default: 
        return ( 
          <>
            <div>{signInStructure}</div>
            <button
              type="submit"
              className={
                props.btnDisabled ? "btn inactive" : "btn active"
              }
              disabled={props.btnDisabled ? "disabled" : ""}
              onClick={() => props.registerHandler()}
              >
              Register
            </button>
          </>
        )
    }
  }

  const signInStructure = props.form.map((value, index) => (
    <div
      key={value + index}
      className="d-flex justify-content-center  no-gutter"
    >
      <InputElement
        id={value.id}
        name={value.id}
        type={value.config.type}
        class="mb-3 col-12 form-group mt-20"
        label={value.config.label}
        required={value.config.validation.require}
        value={value.config.value}
        onChangeHandler={props.onChangeHandler}
        formName={props.formName}
        onBlurHandler={props.onBlurHandler}
        errorMsg={value.config.errorMsg}
        valid={value.config.valid}
        maxLength={value.config.maxLength}
      />
    </div>
  ));
  return (
    <React.Fragment>
      <>
        {returnElement()}
        {props.status === REGISTRATION_STATUS._FAILURE &&
          <div className="error-msg">
            Registration failed. Please try again.
          </div>
        } 
      </>
    </React.Fragment>
  );
};

export default withRouter(EventRegister);
